import { tuiCreateTimePeriods } from '@taiga-ui/kit';

export const TIME_ITEMS = tuiCreateTimePeriods(0, 24, [0, 15, 30, 45]);
